import { Column } from "react-stately";

import type { SpectrumColumnProps } from "@react-types/table";
import type { HTMLAttributes, JSX } from "react";

export type TableColumnProps<T> = Omit<SpectrumColumnProps<T>, "showDivider"> &
  Omit<HTMLAttributes<HTMLTableCellElement>, keyof SpectrumColumnProps<T>>;

export const TableColumn = Column as <T>(props: TableColumnProps<T>) => JSX.Element;
